import { z } from "zod";

export enum AuthScopes {
  patient = "patient",
  page = "page",
}

export const authScopes = [...Object.values(AuthScopes)] as const;
export type AuthScope = (typeof authScopes)[number];

export const rawScopeShema = z.object({
  path: z.string(),
  parsedHash: z.instanceof(URLSearchParams),
});
export type RawScopeType = z.infer<typeof rawScopeShema>;

export const authScopeSchema = z.object({
  path: z.string(),
  token: z.string(),
});

// patient
export const patientAuthScopeSchema = z
  .object({
    ehrPatientId: z.string(),
    ehrPractitionerId: z.string().optional(),
  })
  .merge(authScopeSchema);
export type PatientAuthScope = z.infer<typeof patientAuthScopeSchema>;

// page
export const pageAuthScopeSchema = z.object({}).merge(authScopeSchema);
export type PageAuthScope = z.infer<typeof pageAuthScopeSchema>;

export type AuthScopeDetails = PatientAuthScope | PageAuthScope;
export const authScopeSchemaMap: {
  [key in AuthScope]: z.Schema<AuthScopeDetails>;
} = {
  [AuthScopes.patient]: patientAuthScopeSchema,
  [AuthScopes.page]: pageAuthScopeSchema,
};
